// src/assets/icons/icon-linkedin-logo.tsx
import { jsx } from "react/jsx-runtime";
var IconLinkedinLogo = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M463 0H36.9A36.5 36.5 0 0 0 0 36v427.9A36.55 36.55 0 0 0 36.9 500H463a36.75 36.75 0 0 0 37-36.1V36a36.58 36.58 0 0 0-37-36M148.41 426.11H74.1V187.43h74.31Zm-37.2-271.35a43 43 0 0 1 0-86 43 43 0 0 1 .08 86Zm315 271.35h-74.14V310c0-27.64-.51-63.28-38.53-63.28C275 246.71 269 276.87 269 308v118.11h-74.06V187.43h71v32.62h1a78 78 0 0 1 70.3-38.52c75.1 0 88.95 49.41 88.95 113.65Z" })
  }
);
export {
  IconLinkedinLogo
};
